export default [
  {
    path: '/message',
    component: () => import('@/views/Message.vue'),
    name: 'message',
    meta: {
      navName: 'message',
      sideNav: true,
      requiresAuth: true
    },
  },
  {
    path: '/message/new',
    component: () => import('@/views/Message/New.vue'),
    name: 'message-new',
    meta: {
      navName: 'message',
      sideNav: true,
      requiresAuth: true
    }
  },
  {
    path: '/message/:id',
    component: () => import('@/views/Message/Edit.vue'),
    name: 'message-edit',
    meta: {
      navName: 'message',
      sideNav: true,
      requiresAuth: true
    }
  },
]
